// extracted by mini-css-extract-plugin
export default {"root":"ModalFooter-module--root--36f82"};